import { useEffect } from "react";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import { Grid } from "modules/common/components/Grid";
import PlanBox from "modules/common/components/PlanBox";
import { ChakraBox as Box, ChakraText as Text, ChakraFlex as Flex } from "@airhelp/react-ui-components";
import { trackEcommerceEvent } from "utils/tracking";
import { PRICING_PLANS_ANCHOR, usePricingPlanDetailsConfig } from "./config";
import {
  CHOOSE_PRODUCT_ESSENTIAL_EVENT_UA,
  CHOOSE_PRODUCT_COMPLETE_EVENT_UA,
} from "./trackingConsts";
import {
  useGetViewItemTrackingEvent,
  useGetSelectItemTrackingEvent,
} from "./trackingUtils";

const AhPlusPricingPlans = () => {
  const translations = useTranslations();
  const plansConfig = usePricingPlanDetailsConfig();
  const { essential: essentialPlan, complete: completePlan } = plansConfig;

  const viewItemTrackingEvent = useGetViewItemTrackingEvent();
  const selectItemTrackingEventEssential = useGetSelectItemTrackingEvent("essential");
  const selectItemTrackingEventComplete = useGetSelectItemTrackingEvent("complete");

  useEffect(() => {
    trackEcommerceEvent(viewItemTrackingEvent);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return (
    <Box bg="primary.900" py={{ base: 10, sm: 20 }} id={PRICING_PLANS_ANCHOR}>
      <Grid mb={0}>
        <Flex gridColumn={{ base: "span 1", md: "span 12" }} flexDir="column">
          <Flex
            flexDir={{ base: "column", md: "row" }}
            justify="center"
            align={{ base: "center", md: "stretch" }}
            pt={12}
            gap={{ base: 12, md: "initial" }}
          >
            {/* @ts-ignore */}
            <PlanBox
              planDetails={essentialPlan}
              gaEvent={selectItemTrackingEventEssential}
              uaEvent={CHOOSE_PRODUCT_ESSENTIAL_EVENT_UA}
            />
            {/* @ts-ignore */}
            <PlanBox
              planDetails={completePlan}
              gaEvent={selectItemTrackingEventComplete}
              uaEvent={CHOOSE_PRODUCT_COMPLETE_EVENT_UA}
            />
          </Flex>
          <Text px={8} color="white" fontSize="lg" textAlign="center" mt={{ base: 12, md: 16 }}>
            {translations("plan_no_matter_where_you_flying")}
          </Text>
        </Flex>
      </Grid>
    </Box>
  );
};

export default AhPlusPricingPlans;
